module.exports = __webpack_public_path__ + "static/media/vrf-line.2f6e8020.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Svgs/vrf-line.svg
// module id = 533
// module chunks = 0